import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFilteredLocationList } from 'redux/selectors';

const useLocationList = (
  locationList,
  selectedLocationId,
  selectedLocation
) => {
  const dispatch = useDispatch();
  const [isSearch, setIsSearch] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const filteredLocationList = useSelector(selectFilteredLocationList);
  const {
    business: { businessClassification },
  } = useSelector((business) => business);

  const activeLocation = (item) => {
    if (
      (selectedLocation && item.businessId === selectedLocation?.businessId) ||
      (selectedLocation && item.businessId === selectedLocation?.businessId)
    ) {
      return 'active-location';
    } else if (item.businessId === selectedLocationId) {
      return 'active-location';
    } else if (
      !selectedLocation &&
      !selectedLocationId &&
      selectedBrand?.value?.locations[0]?.businessId === item.businessId
    ) {
      return 'active-location';
    }
    return '';
  };

  const mappedLocations = (classifications) => {
    const filtered = businessClassification?.filter((item) =>
      classifications.includes(item?._id)
    );
    return filtered?.length > 0
      ? `(${filtered?.map((item) => item?.shortName)})`
      : '';
  };

  const handleLocationSelect = (item) => {
    dispatch({ type: 'SET_CURRENT_LOCATION', payload: item });
  };

  const normalize = (str) =>
    str
      ?.toString()
      .toLowerCase()
      .replace(/[\s\-().+]/g, '') || '';

  const handleLocationChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    const sanitizedValue = value.trim();

    if (!sanitizedValue) {
      setIsSearch(false);
      return;
    }

    setIsSearch(true);

    const filteredLocations = locationList?.filter((location) => {
      const searchFields = [
        location.businessId,
        location.businessUuid,
        location.companyName,
        location.locationName,
        location.locationPhone,
        location.address,
        location.restaurantMailbox,
        location.addressInfo?.address,
        location.addressInfo?.fullAddress,
        ...(location.classifications?.map(
          (c) => c?.shortName || c?.name || ''
        ) || []),
      ];

      return searchFields.some((field) =>
        normalize(field).includes(normalize(sanitizedValue))
      );
    });

    dispatch({ type: 'SET_SEARCH_LOCATION', payload: filteredLocations });
    if (filteredLocations.length > 0) {
      dispatch({
        type: 'SET_CURRENT_LOCATION',
        payload: filteredLocations[0],
      });
    }
  };

  // Use filtered data when search is active, otherwise use original locationList
  const displayLocationList = isSearch ? filteredLocationList : locationList;

  return {
    displayLocationList,
    handleLocationChange,
    handleLocationSelect,
    isSearch,
    searchValue,
    filteredLocationList,
    locationList,
    activeLocation,
    mappedLocations,
  };
};

export default useLocationList;
